module.exports = __webpack_public_path__ + "img/DataWorkflowsInactive.7e8554d1.svg";